export const API_BASE_URL =
  (process.env.REACT_APP_API_URL || 'http://localhost:9000').replace(/\/+$/, '');

export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === '1';

export const ON_CALLBACK = window.location.pathname.startsWith('/auth/callback');
export const HAS_CODE = new URLSearchParams(window.location.search).has('code');
